<template>
  <v-container>
    <div class="page-title">{{$route.name}}</div>

    <v-row>
      <v-col class="d-flex justify-end">
        <c-btn class="mx-1" color="blue" outlined @click="onUndoReservationCancel" :disabled =isPossibleUndo>예약 복구</c-btn>
        <c-btn class="mx-1" color="grey" outlined iconName="mdi-format-list-bulleted-square" @click="$router.go(-1)">
          돌아가기
        </c-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <c-card>
          <reservation-detail
            :reservationData="reservationDetailData"
            :canceled-flag="true"
            reservationStateEventFlag
            @changeReservationState="onChangeReservationState"
          />
        </c-card>
      </v-col>
    </v-row>

    <v-row v-if="getUncollectedMoneyData('resrvState')">
      <v-col class="pt-0">
        <c-card class="white">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="2">
                <span class="font-weight-black">수금 여부</span>
              </v-col>
              <v-col cols="12" sm="6" md="10" class="align-self-center">
                <div v-if="editableFlag">
                  <v-radio-group v-model="payment" row class="ma-0">
                    <v-radio label="수금" value="Y"></v-radio>
                    <v-radio label="미수금" value="N"></v-radio>
                  </v-radio-group>
                </div>
                <span v-else>{{ getUncollectedMoneyData('payment') }}</span>
              </v-col>
              <v-col cols="12" sm="6" md="2" class="align-self-center">
                <span class="font-weight-black" >수금 일시</span>
              </v-col>
              <v-col cols="12" sm="6" md="10">
                <div v-if="editableFlag" class="ma-0">
                  <v-menu
                    v-model="paydayMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <div style="width: 200px">
                        <v-text-field
                          v-model="payday"
                          label="입금일"
                          append-icon="event"
                          readonly
                          v-on="on"
                          class="pa-0"
                          :disabled="payment === 'N'"
                        ></v-text-field>
                      </div>
                    </template>
                    <c-date-picker v-model="payday" @input="paydayMenu = false" firstDayOfWeek="1" :disabled="payment === 'N'" :selectedDate="payday"></c-date-picker>
                  </v-menu>
                </div>
                <span v-else>{{ paidFlag ? getUncollectedMoneyData('payday') : '-' }}</span>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <span class="font-weight-black">입금자명</span>
              </v-col>
              <v-col cols="12" sm="6" md="10">
                <v-text-field
                  v-model="depositName"
                  outlined
                  dense
                  class="ma-0 pa-0 infoEditTextField"
                  v-if="editableFlag"
                  :disabled="payment === 'N'"
                  :readonly="useSameName"
                  style="width: 200px; display: inline-block"
                  maxlength="32"
                ></v-text-field>
                <span v-else>{{ paidFlag ? getUncollectedMoneyData('depositName') : '-' }}</span>
                <v-checkbox 
                  v-if="editableFlag"
                  label="예약자와 동일"
                  v-model="useSameName"
                  @change="toggleCustomerName"
                  dense
                  :disabled="payment === 'N'"
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
              <span v-if="editableFlag">
                    <c-btn @click="onUpdatePaymentInfo" outlined color="red">저장</c-btn>
                    <c-btn @click="editableFlag = false" class="ml-1" outlined color="red">취소</c-btn>
              </span>
                <c-btn v-else @click="onUpdatablePaymentInfo" outlined color="red">변경</c-btn>
              </v-col>
            </v-row>
          </v-container>
        </c-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ReservationDetail from "@/views/CallTaxi/Reserve/ReservationDetailDialog";

  export default {
    components: {ReservationDetail},
    data() {
      return {
        reservationDetailData: null,

        canceledReservationInfo: [],
        canceledReservationId: null,

        paidFlag: false,
        editableFlag: false,

        payment: '',
        payday: this.$func.curDateString(),
        depositName: '',

        paydayMenu: false,
        useSameName: false,
      }
    },
    mounted() {
      const {canceledReservationId} = this.$route.params;
      this.canceledReservationId = canceledReservationId;
      this.reqCanceledReservation();
    },
    watch: {
      payment(newVal) {
        if (newVal) {
          this.payday = null;
          this.depositName = null;
          this.useSameName = false;
        }
      }
    },
    computed:{
      isPossibleUndo() {
        return  this.reservationDetailData && this.reservationDetailData.passengerList.filter(item => item.passengerType === 'BOOKER' && item.customerState === 'Disable').length > 0 ? true : false;
      }
    },
    methods: {
      onUndoReservationCancel() {
        this.$store.commit('alert',
            {
              open: true, persistent: true, msg: "취소된 예약을 복구하시겠습니까?",
              confirm: true, callBack: () => {
                this.$router.push( `/reserve/undo/${this.$route.params.canceledReservationId}`)
              }
            });
      },
      async reqCanceledReservation() {
        try {
          const res = await this.$api.getCanceledReservation(this.canceledReservationId);
          this.reservationDetailData = res.data;
          this.setPaymentData();
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqCanceledReservation'});
        }
      },
      async reqUpdateCanceledReservation(data) {
        try {
          await this.$api.updateCanceledReservation(data);
          this.reqCanceledReservation();
          this.editableFlag = false;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqUpdateCanceledReservation'});
        }
      },
      getUncollectedMoneyData(key) {
        if (this.canceledReservationInfo && this.canceledReservationInfo.length > 0) {
          let data = this.canceledReservationInfo[0][key];
          if (key === 'resrvState') {
            data = (data.configValue === 'rs_user_cancel');
          } else if (key === 'payment') {
            if (data === 'Y') {
              data = '수금';
              this.paidFlag = true;
            } else if (data === 'N') {
              data = '미수금';
            }
          } else if (key === 'payday') {
            data = data ? this.$moment(data).format('YYYY년 M월 D일') : '-';
          }
          return data;
        } else {
          return '';
        }
      },
      onChangeReservationState(state) {
        const reqData = {
          reservationId: this.canceledReservationId,
          configString: state
        };
        this.reqUpdateCanceledReservation(reqData)
      },
      onUpdatePaymentInfo() {
        if (this.payment === 'Y' && !(this.payday && this.depositName)) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '입력 정보를 다시 확인해주세요.'});
          return;
        }

        const reqData = {
          reservationId: this.canceledReservationId,
          payment: this.payment,
          payday: this.payday,
          depositName: this.depositName
        }

        this.reqUpdatePaymentInfo(reqData);
      },
      onUpdatablePaymentInfo() {
        this.setPaymentData();
        this.editableFlag = true;
      },
      toggleCustomerName() {
        if ( this.useSameName ) {
          this.depositName = this.canceledReservationInfo[0].customerName;
        }
      },
      async reqUpdatePaymentInfo(data) {
        try {
          await this.$api.updatedPaymentInfo(data);
          await this.reqCanceledReservation();
          this.editableFlag = false;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqUpdatePaymentInfo'});
        }
      },
      setPaymentData() {
        if (this.reservationDetailData) {
          const reservationData = this.reservationDetailData;
          this.canceledReservationInfo = reservationData.canceledReservationList;
          let canceledReservation = reservationData.canceledReservationList[0];
          this.payment = canceledReservation.payment;
          this.payday =  canceledReservation.payday ? this.$func.dateToString(canceledReservation.payday) : '';
          this.depositName = canceledReservation.depositName;
        }
      }
    },
  }
</script>

<style scoped>
  .infoEditTextField {
    font-size: 15px;
    font-weight: bold;
  }

</style>